import { Component, Inject, Vue, Mixins, Watch } from "vue-property-decorator";
import Ribbon from "@/core/ribbon/ribbon.vue";
import Alert from "@/shared/components/alert/alert.vue";

import LoginForm from "@/core/login-form/login-form.vue";
import TranslationService from "./shared/services/translation.service";
import GlobalMixin from "./shared/mixins/global-mixin";

@Component({
  components: {
    ribbon: Ribbon,
    "login-form": LoginForm,
    Alert,
  },
})
export default class App extends Mixins(GlobalMixin) {
  @Inject("translationService") public translationService: () => TranslationService;

  private appReady = false;
  private showAlert = null;
  public mounted() {
    this.setYmlConstants(); // init store with yml constants
    let choice = this.$cookies.get("cookie_choice_opt");
    // replace cookie if value is previously managed value (i.e. 'accepted' instead of consent)
    // code can be removed in December, 2023
    if (choice == "accepted") {
      choice = {
        ad_storage: "granted",
        analytics_storage: "granted",
        functionality_storage: "granted",
        security_storage: "granted",
      };
      this.$cookies.set("cookie_choice_opt", choice, 60 * 60 * 24 * 30 * 2);
    }
    if (choice !== null) this.startGtagTracking(choice);

    if(navigator.language && navigator.language === 'fr-CA'){
      localStorage.setItem('currentLanguage', navigator.language);
      this.changeLanguage(navigator.language);
    }else{
      localStorage.setItem('currentLanguage', 'fr');
      this.changeLanguage('fr');
    }
    
    this.appReady = true;
  }

  public changeLanguage(newLanguage: string): void {
    this.translationService().refreshTranslation(newLanguage);
  }

  public isActiveLanguage(key: string): boolean {
    return key === this.$store.getters.currentLanguage;
  }

  @Watch("$store.state.dashboardStore.showAlert")
  displayAlert() {
    this.showAlert = this.$store.state.dashboardStore.showAlert;
    setTimeout(() => {
      this.$store.commit("showAlert", null);
    }, 6000);
  }
}
